/**
 * Rewrites backend-provided QHLS dashboard links (#/org/qhls) to include the
 * current org scope when the user is browsing /org/:sub_level/:id/...
 */
export function scopeQhlsDashboardLink(rawLink, route) {
    if (!rawLink || !route?.params) return rawLink;
    const sub = route.params.sub_level;
    const id = route.params.id;
    if (sub === undefined || sub === null || String(sub).trim() === '') return rawLink;
    if (id === undefined || id === null || String(id).trim() === '') return rawLink;

    const link = String(rawLink);
    const hashIdx = link.indexOf('#');
    const pathPart = hashIdx >= 0 ? link.slice(hashIdx + 1) : link;
    const normalized = pathPart.replace(/^\//, '');
    if (normalized === 'org/qhls' || normalized.startsWith('org/qhls?')) {
        const qs = normalized.includes('?') ? '?' + normalized.split('?')[1] : '';
        const newPath = `/org/${sub}/${id}/qhls${qs}`;
        if (hashIdx >= 0) {
            return link.slice(0, hashIdx + 1) + newPath;
        }
        return '#' + newPath;
    }
    return rawLink;
}
